import React from 'react';

import { sanitizeMessageHtml } from '../../utils/html';

export default function HtmlMessage({ content }) {
  const html = React.useMemo(() => sanitizeMessageHtml(content), [content]);

  if (!html) {
    return 'אין מידע להצגה';
  }

  return <div className="message-html" dangerouslySetInnerHTML={{ __html: html }} />;
}
